import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { AutoComplete } from "primereact/autocomplete";

const AddRowDialog = ({
  visible,
  onHide,
  onSearch,
  onSubmit,
  loading = false,
  error = "",
}) => {
  const [value, setValue] = React.useState(null);
  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    if (!visible) {
      setValue(null);
      setOptions([]);
    }
  }, [visible]);

  const footer = (
    <div>
      <Button label="Отменить" className="p-button-text" onClick={onHide} />
      <Button label="Добавить" loading={loading} onClick={() => onSubmit(value, () => setValue(null))} />
    </div>
  );

  const completeMethod = async (event) => {
    const result = await onSearch(event.query);
    setOptions(result);
  };

  return (
    <Dialog header="Добавить строку" visible={visible} style={{ width: "38rem" }} onHide={onHide} footer={footer} modal>
      <div className="p-fluid" style={{ display: "grid", gap: "1rem" }}>
        <span className="p-float-label">
          <AutoComplete
            inputId="kato-search"
            value={value}
            suggestions={options}
            completeMethod={completeMethod}
            field="nameRu"
            onChange={(event) => setValue(event.value)}
            itemTemplate={(item) => (
              <div>
                <div>{item.nameRu || item.label || item.name}</div>
                <small>{item.kato || item.code || item.value}</small>
              </div>
            )}
          />
          <label htmlFor="kato-search">КАТО</label>
        </span>
        {error ? (
          <div style={{ color: "#b42318", fontSize: "0.9rem" }}>{error}</div>
        ) : null}
      </div>
    </Dialog>
  );
};

export default AddRowDialog;
